import { Loader, EmailSentModal } from 'components';
import { ForgotPasswordUI } from 'features';
import { useRequestResetPassword } from 'hooks';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'router';

/**
 * Interface for request reset password payload
 */
export interface RequestResetPasswordPayload {
  email: string;
}

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');

  // Hooks
  const { mutate: requestResetPassword, isPending } = useRequestResetPassword(setSuccess, setEmail);

  const submit = (email: string) => {
    requestResetPassword({ email: email.replaceAll('+', '%2B') });
  };

  const showLoader = isPending;

  return (
    <>
      <Loader loading={showLoader} />
      <EmailSentModal show={success} close={() => setSuccess(false)} email={email} onResend={() => submit(email)} />
      <ForgotPasswordUI
        success={success}
        submit={submit}
        handleLogin={() => navigate(Routes.signin)}
      />
    </>
  );
};

export { ForgotPassword };